module.exports = __webpack_public_path__ + "static/lato-v14-latin-300-ba2452bdc790a4fee05202eac3c092b3.woff";